<template>
  <b-card>
    <validation-observer ref="updateProfileForm" #default="{ invalid }">
      <!-- form -->
      <n-form-confirmation
        key="updateProfileForm"
        @submit="submit"
        :form="$refs.updateProfileForm"
        :disabled="invalid"
      >
        <b-row>
          <b-col sm="6">
            <b-form-group :label="$t('field.firstName')" label-for="firstName">
              <validation-provider
                #default="{ errors }"
                vid="firstName"
                :name="$t('field.firstName')"
                rules="required"
              >
                <b-form-input
                  v-model="data.firstName"
                  :placeholder="$t('field.firstName')"
                  :class="errors.length > 0 ? 'is-invalid' : null"
                  name="firstName"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col sm="6">
            <b-form-group :label="$t('field.lastName')" label-for="lastName">
              <validation-provider
                #default="{ errors }"
                vid="lastName"
                :name="$t('field.lastName')"
                rules="required"
              >
                <b-form-input
                  v-model="data.lastName"
                  :placeholder="$t('field.lastName')"
                  :class="errors.length > 0 ? 'is-invalid' : null"
                  name="lastName"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col sm="6">
            <b-form-group :label="$t('field.email')" label-for="email">
              <validation-provider
                #default="{ errors }"
                vid="email"
                :name="$t('field.email')"
                rules="required|email"
              >
                <b-form-input
                  v-model="data.email"
                  :placeholder="$t('field.email')"
                  :class="errors.length > 0 ? 'is-invalid' : null"
                  name="email"
                  :disabled="true"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12" class="text-right">
            <n-button-loading
              type="submit"
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              class="mt-1 mr-1"
              :loading="loading"
              :disabled="invalid"
            >
              {{ $t("button.saveChanges") }}
            </n-button-loading>
            <n-button-loading
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              variant="outline-secondary"
              :loading="loading"
              class="mt-1"
              @submit="resetForm"
            >
              {{ $t("button.reset") }}
            </n-button-loading>
          </b-col>
        </b-row>
      </n-form-confirmation>
    </validation-observer>
  </b-card>
</template>

<script>
import {
  BButton,
  BCard,
  BCardText,
  BCol,
  BForm,
  BFormDatepicker,
  BFormGroup,
  BFormInput,
  BFormRadioGroup,
  BLink,
  BRow,
  BImg,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import NButtonLoading from "@/components/NButtonLoading";
import NFormConfirmation from "@/components/NFormConfirmation";
import Repository from "@/repositories/RepositoryFactory";
import NSingleImageUploader from "@/components/NSingleImageUploader";
import NCurrencyInput from "@/components/NCurrencyInput";

const ProfileRepository = Repository.get("profile");

export default {
  components: {
    BButton,
    BForm,
    BFormGroup,
    BFormInput,
    BRow,
    BCol,
    BCard,
    BCardText,
    BLink,
    BFormRadioGroup,
    BImg,
    NButtonLoading,
    NFormConfirmation,
    NSingleImageUploader,
    BFormDatepicker,
    NCurrencyInput,
  },
  directives: {
    Ripple,
  },
  props: {
    generalData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      data: JSON.parse(localStorage.getItem("userData")),
      genderOptions: [
        { text: this.$t("general.male"), value: "male" },
        { text: this.$t("general.female"), value: "female" },
      ],
      loading: false,
    };
  },
  methods: {
    submit() {
      this.$refs.updateProfileForm.validate().then((success) => {
        if (success) {
          this.loading = true;
          ProfileRepository.updateProfile(this.data)
            .then((response) => {
              const user = response.data.data;
              localStorage.setItem("userData", JSON.stringify(user));
              this.$store.commit("profile/UPDATE_PROFILE", user);
            })
            .catch((error) => {
              if (error.response?.data?.message) {
                this.$refs.updateProfileForm.setErrors(
                  error.response?.data?.message
                );
              }
            })
            .then(() => {
              this.loading = false;
            });
        }
      });
    },
    resetForm() {
      this.data = JSON.parse(localStorage.getItem("userData"));

      this.$nextTick(() => {
        this.$refs.updateProfileForm.reset();
      });
    },
  },
};
</script>
